import { render, staticRenderFns } from "./EditVerticalConfiguration.vue?vue&type=template&id=67ac4bb4&"
import script from "./EditVerticalConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditVerticalConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports